/**
 * @file src/utils/colorUtils.ts
 * @description This file defines utility functions for managing color classes used in various components of the application, particularly for styling portfolio items based on their state.
 * @module colorUtils
 */

import { TextVariants } from '@/components';

export const getColorBasedOnState = (
  state: string | undefined,
): TextVariants['color'] => {
  switch (state) {
    case 'INITIATED':
    case 'PENDING_RISK_SCREENING':
    case 'QUEUED':
    case 'SENT':
      return 'warning';
    case 'FAILED':
    case 'CANCELLED':
      return 'error';
    default:
      return undefined;
  }
};
